module.exports = __webpack_public_path__ + "img/hu.25867a46.svg";